<div class="modal z-50 fixed w-screen h-full top-0 left-0 flex items-center justify-center p-5 lg:p-0">
  <div class="modal-overlay fixed w-full h-full bg-gray-900 opacity-50"></div>

  <div
    class="bg-white w-full lg:max-w-screen-lg mx-auto rounded-2xl shadow-xl z-50 overflow-y-auto flex flex-col max-h-[90vh]"
  >
    <!-- Header -->
    <div class="flex justify-between items-center px-6 py-4 border-b border-alto">
      <div>
        <h1 class="text-lg font-bold text-chathams-blue">Configurar as opções do módulo</h1>
        <span class="text-sm text-gray-400">{{ module?.name }}</span>
      </div>
      <button
        class="w-10 h-10 rounded-lg btn btn--secondary flex items-center justify-center text-sm font-bold"
        [routerLink]="['/dash/setups/editar', setupId]"
      >
        X
      </button>
    </div>

    <!-- Tabs -->
    <div class="flex gap-2 px-6 pt-4">
      <button
        class="btn h-9 px-5 text-sm"
        [ngClass]="activeTab === 'configuracoes' ? 'btn--secondary' : 'btn--secondary--light'"
        (click)="activeTab = 'configuracoes'"
      >
        Configurações
      </button>
      <button
        class="btn h-9 px-5 text-sm"
        [ngClass]="activeTab === 'comportamento' ? 'btn--secondary' : 'btn--secondary--light'"
        (click)="activeTab = 'comportamento'"
      >
        Comportamento
      </button>
    </div>

    <!-- Body -->
    <form class="flex flex-col gap-4 p-6" [formGroup]="formConfigModule">
      <!-- Tab: Configurações do módulo -->
      <div *ngIf="activeTab === 'configuracoes'" class="bg-white rounded-2xl shadow-md px-6 py-5">
        <h3 class="font-bold text-chathams-blue mb-4">Configurações do módulo</h3>

        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
          <ng-container *ngFor="let field of configSchemaArray">
            <ng-container *ngIf="getControl(field.key) as control">
              <div
                class="form-group"
                [class.col-span-2]="
                  field.value.type === 'array' &&
                  !field.value.options?.length &&
                  field.value.optionsType !== 'copsoq-form-id'
                "
              >
                <label class="font-bold text-sm">{{ field.value.description }}</label>

                <input
                  *ngIf="field.value.type === 'string' && field.value.optionsType !== 'npsSurvey'"
                  type="text"
                  class="form-input"
                  placeholder="{{ field.value.description }}"
                  [formControl]="control"
                />

                <input
                  *ngIf="isNumericType(field.value.type)"
                  type="number"
                  min="0"
                  class="form-input"
                  placeholder="Ex: 30 (dias)"
                  [formControl]="control"
                />

                <input
                  *ngIf="isUnknownType(field.value.type)"
                  type="text"
                  class="form-input"
                  placeholder="{{ field.value.description }}"
                  [formControl]="control"
                />

                <ng-select
                  *ngIf="field.value.type === 'string' && field.value.optionsType === 'npsSurvey'"
                  notFoundText="Nenhuma pesquisa encontrada"
                  [searchable]="true"
                  [formControl]="control"
                >
                  <ng-option *ngFor="let survey of npsSurveys" [value]="survey.id">
                    {{ survey.name }}{{ survey.companyId === null ? ' (Padrão do sistema)' : ''
                    }}{{ survey.status !== 1 ? ' (Inativa)' : '' }}
                  </ng-option>
                </ng-select>

                <div
                  *ngIf="field.value.type === 'string' && field.value.optionsType === 'npsSurvey' && !companyId"
                  class="text-xs text-red-500 py-2"
                >
                  Defina a empresa do setup para carregar as pesquisas NPS.
                </div>

                <div
                  *ngIf="
                    field.value.type === 'string' &&
                    field.value.optionsType === 'npsSurvey' &&
                    companyId &&
                    !npsSurveys.length
                  "
                  class="text-xs text-gray-400 py-2"
                >
                  Nenhuma pesquisa NPS disponível.
                </div>

                <div
                  *ngIf="
                    field.value.type === 'string' &&
                    field.value.optionsType === 'npsSurvey' &&
                    companyId &&
                    npsSurveys.length &&
                    !control.value
                  "
                  class="text-xs text-yellow-600 py-2"
                >
                  Selecione uma Pesquisa NPS para o módulo Finish funcionar corretamente.
                </div>

                <ng-select
                  *ngIf="field.value.type === 'bool'"
                  notFoundText="Nenhum item encontrado"
                  [searchable]="false"
                  [formControl]="control"
                >
                  <ng-option [value]="true">Sim</ng-option>
                  <ng-option [value]="false">Não</ng-option>
                </ng-select>

                <ng-select
                  *ngIf="field.value.type === 'array' && field.value.options?.length"
                  notFoundText="Nenhum item encontrado"
                  [searchable]="false"
                  [formControl]="control"
                >
                  <ng-option *ngFor="let option of field.value.options" [value]="option">{{ option }}</ng-option>
                </ng-select>

                <ng-select
                  *ngIf="field.value.type === 'array' && field.value.optionsType === 'copsoq-form-id'"
                  notFoundText="Nenhum item encontrado"
                  [searchable]="false"
                  [formControl]="control"
                >
                  <ng-option *ngFor="let customQuestionnaire of customQuestionnaires" [value]="customQuestionnaire.id">
                    {{ customQuestionnaire.name }}
                  </ng-option>
                </ng-select>

                <div *ngIf="field.value.type === 'array' && field.value.optionsType === 'modules'">
                  <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-3">
                    <div
                      *ngFor="let module of modules"
                      class="p-3 bg-white border rounded-lg shadow-sm hover:shadow-md transition-shadow transition-colors duration-150 cursor-pointer"
                      [class.border-blue-400]="control.value?.includes(module.route)"
                      [class.bg-blue-50]="control.value?.includes(module.route)"
                    >
                      <label class="flex items-center justify-between gap-3 cursor-pointer">
                        <span class="text-sm font-medium text-chathams-blue break-words">{{ module.name }}</span>
                        <input
                          type="checkbox"
                          [checked]="control.value?.includes(module.route)"
                          (change)="onModuleCheckboxChange($event, field.key, module.route)"
                          class="w-5 h-5 rounded border-gray-300 focus:ring-2 focus:ring-offset-1 focus:ring-cerise-red"
                        />
                      </label>
                      <div
                        *ngIf="
                          control.value?.includes(module.route) &&
                          getControl('enabledPaths') &&
                          module.route !== 'Module_SkinCare'
                        "
                        class="mt-2 pt-2 border-t border-gray-200"
                      >
                        <label class="flex items-center gap-2 cursor-pointer">
                          <input
                            type="checkbox"
                            [checked]="isModuleEnabledPath(module.route)"
                            (change)="toggleModuleEnabledPath(module.route, $any($event.target).checked)"
                            class="w-4 h-4 rounded border-gray-300 focus:ring-2 focus:ring-cerise-red"
                          />
                          <span class="text-xs text-gray-500 font-medium">Atendimento de Saúde</span>
                        </label>
                        <label
                          *ngIf="isModuleEnabledPath(module.route)"
                          class="flex items-center gap-2 cursor-pointer mt-2"
                        >
                          <input
                            type="checkbox"
                            [checked]="isModuleShowAsCard(module.route)"
                            (change)="toggleModuleShowAsCard(module.route, $any($event.target).checked)"
                            class="w-4 h-4 rounded border-gray-300 focus:ring-2 focus:ring-cerise-red"
                          />
                          <span class="text-xs text-gray-500 font-medium">Exibir também como card no Intro</span>
                        </label>
                      </div>
                    </div>
                  </div>

                  <div *ngIf="getControl('enabledPaths') && enabledPathsOrdered.length > 0" class="mt-4">
                    <h4 class="text-sm font-bold text-gray-600 mb-2">
                      Ordem de Atendimento de Saúde (arraste para reordenar)
                    </h4>
                    <div
                      class="border rounded-lg p-2 bg-gray-50"
                      cdkDropList
                      [cdkDropListData]="enabledPathsOrdered"
                      (cdkDropListDropped)="dropEnabledPaths($event)"
                    >
                      <div
                        *ngFor="let path of enabledPathsOrdered; let i = index"
                        cdkDrag
                        class="flex items-center gap-2 p-2 mb-1 bg-white rounded shadow-sm border cursor-move"
                      >
                        <mat-icon class="text-gray-400 text-base">drag_indicator</mat-icon>
                        <span class="text-sm font-bold text-gray-400">{{ i + 1 }}.</span>
                        <span class="text-sm font-medium text-chathams-blue">{{ path.name }}</span>
                      </div>
                    </div>
                  </div>
                </div>

                <div *ngIf="field.value.type === 'array' && field.value.optionsType?.includes('paths')">
                  <div class="mb-4">
                    <h4 class="text-sm font-bold text-gray-600 mb-2">Caminhos Selecionados (arraste para reordenar)</h4>
                    <div
                      class="border rounded-lg p-2 min-h-[60px] bg-gray-50"
                      cdkDropList
                      [cdkDropListData]="control.value || []"
                      (cdkDropListDropped)="dropPaths($event, field.key)"
                    >
                      <div
                        *ngFor="let selectedPath of control.value || []; let i = index"
                        class="flex items-center p-2 mb-1 bg-white rounded shadow-sm border"
                        cdkDrag
                      >
                        <mat-icon class="cursor-move text-gray-400 mr-2">drag_indicator</mat-icon>
                        <span class="text-sm font-medium text-chathams-blue">
                          <span class="font-bold">{{ i + 1 }}.</span> {{ getPathName(selectedPath.key) }}
                        </span>
                        <button
                          type="button"
                          (click)="onPathCheckboxChange({ target: { checked: false } }, field.key, selectedPath.key)"
                        >
                          Remover
                        </button>
                      </div>
                      <div *ngIf="!control.value?.length" class="text-center text-xs text-gray-400 py-4">
                        Nenhum caminho selecionado.
                      </div>
                    </div>
                  </div>

                  <div>
                    <h4 class="text-sm font-bold text-gray-600 mb-2">Caminhos Disponíveis</h4>
                    <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-3">
                      <ng-container *ngFor="let path of paths">
                        <div
                          *ngIf="!isPathSelected(field.key, path.key)"
                          class="p-3 bg-white border rounded-lg shadow-sm hover:shadow-md transition-shadow"
                        >
                          <label class="flex items-center justify-between gap-3 cursor-pointer">
                            <span class="text-sm font-medium text-chathams-blue break-words">{{ path.name }}</span>
                            <input
                              type="checkbox"
                              [checked]="false"
                              (change)="onPathCheckboxChange($event, field.key, path.key)"
                              class="w-5 h-5 rounded border-gray-300"
                            />
                          </label>
                        </div>
                      </ng-container>
                    </div>
                  </div>
                </div>

                <div *ngIf="field.value.type === 'array' && field.value.optionsType === 'customQuestionnaire'">
                  <div class="mb-4">
                    <h4 class="text-sm font-bold text-gray-600 mb-2">
                      Questionários Selecionados (arraste para reordenar)
                    </h4>
                    <div
                      class="border rounded-lg p-2 min-h-[60px] bg-gray-50"
                      cdkDropList
                      [cdkDropListData]="control.value || []"
                      (cdkDropListDropped)="dropPaths($event, field.key)"
                    >
                      <div
                        *ngFor="let selectedQuestionnaire of control.value || []; let i = index"
                        class="flex items-center p-2 mb-1 bg-white rounded shadow-sm border"
                        cdkDrag
                      >
                        <mat-icon class="cursor-move text-gray-400 mr-2">drag_indicator</mat-icon>
                        <span class="text-sm font-medium text-chathams-blue">
                          <span class="font-bold">{{ i + 1 }}.</span>
                          {{ getQuestionnaireName(selectedQuestionnaire.id) }}
                        </span>
                        <button
                          type="button"
                          (click)="
                            onQuestionnaireCheckboxChange(
                              { target: { checked: false } },
                              field.key,
                              selectedQuestionnaire.id
                            )
                          "
                        >
                          Remover
                        </button>
                      </div>
                      <div *ngIf="!control.value?.length" class="text-center text-xs text-gray-400 py-4">
                        Nenhum questionário selecionado.
                      </div>
                    </div>
                  </div>

                  <div>
                    <h4 class="text-sm font-bold text-gray-600 mb-2">Questionários Disponíveis</h4>
                    <div *ngIf="!companyId" class="text-xs text-red-500 py-2">
                      Empresa não identificada para carregar os questionários personalizados.
                    </div>
                    <div *ngIf="companyId && !customQuestionnaires.length" class="text-xs text-gray-400 py-2">
                      Nenhum questionário personalizado disponível.
                    </div>
                    <div
                      *ngIf="companyId && customQuestionnaires.length"
                      class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-3"
                    >
                      <ng-container *ngFor="let questionnaire of customQuestionnaires">
                        <div
                          *ngIf="!isQuestionnaireSelected(field.key, questionnaire.id)"
                          class="p-3 bg-white border rounded-lg shadow-sm hover:shadow-md transition-shadow"
                        >
                          <label class="flex items-center justify-between gap-3 cursor-pointer">
                            <span class="text-sm font-medium text-chathams-blue break-words">{{
                              questionnaire.name
                            }}</span>
                            <input
                              type="checkbox"
                              [checked]="false"
                              (change)="onQuestionnaireCheckboxChange($event, field.key, questionnaire.id)"
                              class="w-5 h-5 rounded border-gray-300"
                            />
                          </label>
                        </div>
                      </ng-container>
                    </div>
                  </div>
                </div>
              </div>
            </ng-container>
          </ng-container>
        </div>
      </div>

      <!-- Tab: Comportamento do módulo -->
      <div *ngIf="activeTab === 'comportamento'" class="bg-white rounded-2xl shadow-md px-6 py-5">
        <h3 class="font-bold text-chathams-blue mb-4">Comportamento do módulo</h3>

        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
          <label
            class="flex items-center justify-between gap-4 p-4 border border-alto rounded-xl cursor-pointer hover:bg-gray-50 transition-colors"
          >
            <div>
              <span class="text-sm font-medium text-chathams-blue">Requer autenticação</span>
              <p class="text-xs text-gray-400 mt-0.5">
                O módulo exige que o usuário esteja autenticado para acessá-lo.
              </p>
            </div>
            <input type="checkbox" formControlName="requiresAuth" class="toggle-checkbox hidden" />
            <span class="toggle-switch"></span>
          </label>

          <label
            class="flex items-center justify-between gap-4 p-4 border border-alto rounded-xl cursor-pointer hover:bg-gray-50 transition-colors"
          >
            <div>
              <span class="text-sm font-medium text-chathams-blue">Requer triagem</span>
              <p class="text-xs text-gray-400 mt-0.5">
                O módulo exige que o usuário passe pela triagem antes de acessá-lo.
              </p>
            </div>
            <input type="checkbox" formControlName="requiresTriage" class="toggle-checkbox hidden" />
            <span class="toggle-switch"></span>
          </label>
        </div>
      </div>

      <!-- Footer -->
      <div class="flex items-center justify-center pb-2">
        <button
          *isAllowed="[ERoleAdminString.Admin, 'setup.edit']"
          class="w-80 h-9 btn btn--secondary"
          (click)="saveModuleSettings()"
        >
          + Salvar configurações do módulo
        </button>
      </div>
    </form>
  </div>
</div>
